/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
function PriceList() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleButtonClick = () => {
    // Open the popup form
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    // Close the popup form
    setIsPopupOpen(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <textarea
          id="w3review"
          name="w3review"
          rows="4"
          cols="50"
          style={{
            height: 300,
            width: "70%",
            background: "white",
            border: "1px solid black",
            marginLeft: "14%",
            marginTop: "5%",
            fontSize: "15px",
          }}
          defaultValue={`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}
        />

        <label>
          <span
            style={{
              marginLeft: "14%",
              marginTop: "10px",
              padding: "5px 10px",
              fontSize: "15px",
              backgroundColor: "green",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
            onClick={handleButtonClick}
            className="bg-red-700 h-[5vh] rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
          >
            Update
          </span>
        </label>

        {isPopupOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.5)",
            }}
          >
            {/* Popup form content */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                background: "white",
                padding: "20px",
                borderRadius: "5px",
              }}
            >
              {/* Your form content goes here */}
              <textarea
                id="w3review"
                name="w3review"
                rows="4"
                cols="50"
                style={{
                  height: 200,
                  width: "100%",
                  background: "white",
                  border: "1px solid black",
                  //   marginLeft: "14%",
                  marginTop: "5%",
                  fontSize: "15px",
                }}
                defaultValue={`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}
              />
              {/* <button onClick={handleClosePopup}>Close</button> */}
              <label>
                <span
                  onClick={handleClosePopup}
                  className="bg-red-700 h-[5vh] rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Close
                </span>

                <span
                  style={{ float: "right" }}
                  onClick={handleClosePopup}
                  className="bg-green-700 h-[5vh] rounded-md w-[4vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Submit
                </span>
              </label>
            </div>
          </div>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PriceList;
